import Box from "@mui/material/Box";
import { styled, alpha } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { fontSize } from "@mui/system";
import ListItem from "@mui/material/ListItem";


export const useStyles = makeStyles((theme) => ({
  outerContainer:{
    backgroundColor:theme.palette.background.main,
    color:theme.palette.text.main,
    padding:theme.spacing(  3,3)
  },

  innerContainer:{
    backgroundColor:theme.palette.background.main,
    color:theme.palette.text.main,
    margin:theme.spacing( 1,0)
  }
 
}));

export const SideBarListItem = styled(ListItem)(({ theme }) => ({
  backgroundColor: theme.palette.background.main,
  fontWeight:"900",
  color:  theme.palette.text.main,
  transition:".5s",
  "&:hover, &:active": {
    backgroundColor: theme.palette.primary.main,
    borderRadius:theme.spacing(1)  ,
    color:alpha(  theme.palette.text.tertiary, 0.8),
   
  },
}));
